import { auto } from 'browser-unhandled-rejection';
import { configure } from 'mobx';
import { createRoot } from 'react-dom/client';
import { getFirebase } from './firebase/FirebaseAdapater';
import { PageFrame } from './page';

import * as Sentry from '@sentry/react';
import { useConfig } from './model/StoreConfig';
import { Flex } from './component/UI/Flex/Flex';
import { Logo } from './component/Header/Logo';
const config = useConfig();
const isProd = process.env.NODE_ENV !== 'development';

if (isProd) {
    console.log('**** Sentry enabled ****');
    Sentry.init({
        dsn: 'https://da20019de005c0cb1ea1e1f5fe326fb7@o4509184942407680.ingest.us.sentry.io/4509184943390720',
        environment: config.clientName
    });
}

getFirebase().init();

auto();

configure({ enforceActions: 'never' });

self.addEventListener('unhandledrejection', ({ reason }) => {
    //const { message } = reason as Error;
    //if (message) self.alert(message);
});

// const { serviceWorker } = window.navigator,
//     NODE_ENV = process.env.NODE_ENV || 'development';

// if (NODE_ENV !== 'development')
//     serviceWorker
//         ?.register('sw.js')
//         .then(serviceWorkerUpdate)
//         .then(worker => {
//             if (
//                 window.confirm(
//                     'New version of this Web App detected, update now?'
//                 )
//             )
//                 worker.postMessage({ type: 'SKIP_WAITING' });
//         });

// serviceWorker?.addEventListener('controllerchange', () =>
//     window.location.reload()
// );

const root = createRoot(document.querySelector('#app'));
const errorPage = (
    <Flex
        style={{ backgroundColor: 'white' }}
        fillCell={true}
        direction="column"
        justify="center"
        alignItems="center"
    >
        <div style={{ transform: 'scale(2)' }}>
            <Flex direction="column" justify="center" alignItems="center">
                <Logo />
                <div style={{ fontSize: '20px', marginTop: '15px' }}>
                    An error has occurred.
                </div>
                <div style={{ fontSize: '8px' }}>
                    An automatic error report has been sent to Flightline.
                </div>
            </Flex>
        </div>
    </Flex>
);

if (isProd) {
    const page = (
        <Sentry.ErrorBoundary fallback={errorPage}>
            <PageFrame />
        </Sentry.ErrorBoundary>
    );
    root.render(page);
} else {
    root.render(<PageFrame />);
}
